export const lineSymbol = {
  path: 'M 0,0 0,1',
  strokeOpacity: 1,
  scale: 2
}

export const polylineOptions = {
  strokeOpacity: 0,
  strokeColor: 'red',
  icons: [
    {
      icon: lineSymbol,
      offset: '0',
      repeat: '7px'
    }
  ]
}